import { useEffect, useState } from "react";
import { TooltipEasy } from "../tooltipEasy";
import { Badge } from "../ui/badge";
import { Clock9, ClockAlert } from "lucide-react";

export function TempoRestante({ tempo }) {
  const [minutosRestantes, setMinutosRestantes] = useState(tempo);

  useEffect(() => {
    if (minutosRestantes <= 0) return;

    const intervalo = setInterval(() => {
      setMinutosRestantes((prev) => prev - 1);
    }, 60000);

    return () => clearInterval(intervalo);
  }, [minutosRestantes]);

  const formatarTempo = (minutos) => {
    if (minutos === 0) return "Expirado"

    if (minutos >= 1440) {
      const dias = Math.floor(minutos / 1440);
      return `${dias} dia${dias > 1 ? "s" : ""}`;
    } else if (minutos >= 60) {
      const horas = Math.floor(minutos / 60);
      return `${horas} hora${horas > 1 ? "s" : ""}`;
    } else {
      return `${minutos} min`;
    }
  };

  return (
    <TooltipEasy
      content="Tempo restante">
      <Badge
        className="bg-[#717171] text-white">
        {tempo === 0 ? <ClockAlert /> : <Clock9 />}
        {formatarTempo(minutosRestantes)}
      </Badge>
    </TooltipEasy>
  );
}